import React from 'react'
import TableLayout from '../../components/TableLayout'

const SubsidiariesListContainer = () => {
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Código',
            dataIndex: 'code',
            sorter: true,
            filtered: true,
        },
        {
            title: 'RFC',
            dataIndex: 'rfc',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Nombre del negocio',
            dataIndex: 'business_name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Dirección',
            dataIndex: 'address',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de sucursales"
                columns={columns}
                resource="subsidiaries"
                actions={['excel','active','create', 'edit', 'show']}
            />
        </>
    )
}

export default SubsidiariesListContainer
